import{GLOBAL_START_EPOCH as t}from"./constants.mjs.js";let o=t+1;export{o as globalEpoch};
//# sourceMappingURL=transactions.mjs.js.map
